import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import WhyTrripHeader from './sections/WhyTrripHeader';
import WhyTrripToggle from './sections/WhyTrripToggle';
import PainPointsGrid from './sections/PainPointsGrid';
import SolutionsGrid from './sections/SolutionsGrid';

const WhyTrripSection = () => {
  const [isResolved, setIsResolved] = useState(false);

  return (
    <section className="py-24 px-6 md:px-12 lg:px-24 bg-gradient-to-b from-[#f8fafc] to-white relative overflow-hidden min-h-[850px] flex items-center">
      {/* Background Decorative Elements */}
      <div
        className={`absolute top-0 left-0 w-full h-[500px] transition-colors duration-1000 -z-10 ${
          isResolved
            ? 'bg-gradient-to-b from-[#067978]/5 to-transparent'
            : 'bg-gradient-to-b from-gray-100 to-transparent'
        }`}
      />
      <div
        className={`absolute -top-[200px] -right-[200px] w-[600px] h-[600px] rounded-full blur-[100px] -z-10 pointer-events-none transition-colors duration-1000 ${
          isResolved ? 'bg-[#067978]/10' : 'bg-gray-200/50'
        }`}
      />

      <div className="max-w-7xl mx-auto w-full flex flex-col items-center">
        {/* Header */}
        <WhyTrripHeader isResolved={isResolved} />

        {/* Toggle Switch */}
        <WhyTrripToggle isResolved={isResolved} onToggle={setIsResolved} />

        {/* Content Area */}
        <div className="w-full relative min-h-[920px] sm:min-h-[780px] md:min-h-[480px] lg:min-h-[350px] flex justify-center">
          <AnimatePresence mode="wait">
            {!isResolved ? <PainPointsGrid /> : <SolutionsGrid />}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default WhyTrripSection;
